import { render, staticRenderFns } from "./addAttr.vue?vue&type=template&id=90653934&scoped=true"
import script from "./addAttr.vue?vue&type=script&lang=js"
export * from "./addAttr.vue?vue&type=script&lang=js"
import style0 from "./addAttr.vue?vue&type=style&index=0&id=90653934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90653934",
  null
  
)

export default component.exports